import React from "react";
import { withSnackbar } from "notistack";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Breadcrumb from "../common/breadcum";
import BudgetLinearProgress from "./BudgetLinearProgress";
import Form from "../common/form";
import ModalEliminar from "./components/modalEliminar";
import { getProjectStatuses } from "../../services/projectStatusService";
import { getMembers } from "../../services/memberService";
import { getProjectComponents } from "../../services/projectComponentService";
import {
  getProjectPlannedBudget,
  getProjectExecutedBudget,
} from "../../services/budgetProject";
import { deleteComponent } from "../../services/componentService";
import ProjectFormI from "./projectFormI";
import ProjectComponentsI from "./components/projectComponentsI";
import PanelFilesResolucionI from "./panelFilesResolucionI";
import PanelFilesInforme1I from "./panelFilesInforme1I";
import PanelFilesInforme2I from "./panelFilesInforme2I";
import PanelFilesActaCierreI from "./panelFileActaCierreI";
import PanelMembersI from "./panelMembersI";
import PanelStatusesI from "./panelStatusesI";

class ProjectMainInv extends Form {
  state = {
    data: {
      slug: this.props.match.params.slug || "",
      id: this.props.match.params.id || "",
    },
    plannedBudget: "0.00",
    executedBudget: "0.00",
    members: [],
    projectStatuses: [],
    projectComponents: [],
    isLoading: false,
    isOpen: false,
    idComponentToDelete: "",
  };

  async populateProjectStatuses() {
    const projectSlug = this.state.data.slug;
    const { data: projectStatuses } = await getProjectStatuses(projectSlug);
    this.setState({ projectStatuses });
  }

  async populateProjectComponents() {
    const projectSlug = this.state.data.slug;
    const { data: projectComponents } = await getProjectComponents(projectSlug);
    this.setState({ projectComponents });
  }

  async populateMembers() {
    const projectSlug = this.state.data.slug;
    const { data: members } = await getMembers(projectSlug);
    this.setState({ members });
  }

  async populatePlannedBudget() {
    const projectSlug = this.state.data.slug;
    const { data: project } = await getProjectPlannedBudget(projectSlug);
    if (project.plannedBudget)
      this.setState({ plannedBudget: project.plannedBudget });
  }

  async populateExecutedBudget() {
    const projectSlug = this.state.data.slug;
    const { data: project } = await getProjectExecutedBudget(projectSlug);
    if (project.executedBudget)
      this.setState({ executedBudget: project.executedBudget });
  }

  handleOpenModal(componentId) {
    this.setState({ isOpen: true, idComponentToDelete: componentId });
  }

  handleCloseModal() {
    this.setState({ isOpen: false });
  }

  async onDeleteComponent(componentId) {
    try {
      const originalComponents = [...this.state.projectComponents];
      const projectComponents = originalComponents.filter(
        (comp) => comp.id !== componentId
      );
      this.handleCloseModal();
      this.setState({ projectComponents });
      await deleteComponent(componentId);
      this.populatePlannedBudget();
      this.populateExecutedBudget();
      this.props.enqueueSnackbar(`Registro eliminado correctamente!`, {
        variant: "success",
      });
    } catch (ex) {
      this.errorMessage(ex);
      //console.log(ex);
    }
  }

  onSubmit(component) {
    try {
      const originalComponents = this.state.projectComponents;
      var projectComponents = originalComponents.map((comp, index) =>
        comp.id === component.id
          ? { ...comp, name: component.name, goal: component.goal }
          : comp
      );
      this.setState({ projectComponents });
    } catch (ex) {
      this.errorMessage(ex);
      //console.log(ex);
    }
  }

  async componentDidMount() {
    this._isMounted = true;
    //this.getStepContent();
    this.setState({ isLoading: true });

    await this.populateProjectStatuses();
    await this.populateProjectComponents();
    await this.populateMembers();
    await this.populatePlannedBudget();
    await this.populateExecutedBudget();
    if (this._isMounted) this.setState({ isLoading: false });
  }

  render() {
    const { data, projectComponents, projectStatuses, members } = this.state;
    const listBreadcrumbs = [
      {
        path: "/proyectosI",
        label: "Proyectos",
      },
    ];
    return (
      <Container maxWidth="xl" id="projectMainInv">
        <Breadcrumb
          onListBreadcrumbs={listBreadcrumbs}
          lastLabel={data.slug.toUpperCase()}
        />

        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={8} xl={9}>
            <ProjectFormI
              projectSlug={data.slug}
              history={this.props.history}
              populateStatuses={() => this.populateProjectStatuses()}
            />
            <Paper className="paper" elevation={10}>
              <Typography variant="h6" gutterBottom>
                EJECUCIÓN PRESUPUESTARIA:
              </Typography>
              <small style={{ color: "white" }}>
                {" "}
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;{" "}
              </small>
              {projectComponents.length > 0 && (
                <ProjectComponentsI
                  title="EJECUCIÓN PRESUPUESTARIA"
                  data={projectComponents}
                  plannedBudget={() => this.populatePlannedBudget()}
                  executedBudget={() => this.populateExecutedBudget()}
                  onOpenDelete={(c) => this.handleOpenModal(c)}
                  populateProjectComponents={this.populateProjectComponents}
                />
              )}
            </Paper>
          </Grid>
          <Grid container item xs={12} sm={12} md={4} xl={3}>
            <Grid item xs={12} sm={12}>
              <Paper className="paper">
                <Typography variant="h6" gutterBottom>
                  Presupuesto asignado:
                </Typography>
                <Typography variant="h6" gutterBottom>
                  $ {this.state.plannedBudget}
                </Typography>
                <Typography variant="h6" gutterBottom>
                  Presupuesto ejecutado:
                </Typography>
                <Typography variant="h6" gutterBottom>
                  $ {this.state.executedBudget}
                  <BudgetLinearProgress
                    total={this.state.plannedBudget}
                    partial={this.state.executedBudget}
                  />
                </Typography>
              </Paper>
              <PanelMembersI
                title="Miembros"
                projectSlug={data.slug}
                data={members}
              />
              <PanelFilesResolucionI projectSlug={data.slug} />
              <PanelFilesInforme1I projectSlug={data.slug} />
              <PanelFilesInforme2I projectSlug={data.slug} />
              <PanelFilesActaCierreI projectSlug={data.slug} />
              <PanelStatusesI
                title="Últimos estados"
                projectSlug={data.slug}
                projectId={data.projectId}
                data={projectStatuses}
              />
            </Grid>
          </Grid>
        </Grid>
        <ModalEliminar
          handleCloseModal={() => this.handleCloseModal()}
          isOpen={this.state.isOpen}
          idComponentToDelete={this.state.idComponentToDelete}
          onDeleteComponent={(c) => this.onDeleteComponent(c)}
        />
      </Container>
    );
  }
}

export default withSnackbar(ProjectMainInv);
